module.exports = __webpack_public_path__ + "static/media/feature-company-interview-reminder.b74ef842.png";